<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Direccion</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Direccion</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <div class="container-fluid">
        <form [formGroup]="form">
            <div class="row align-items-center">

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.Ciudad}}</mat-label>
                        <input type="text" matInput formControlName="ciudad">
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline">
                        <mat-label>{{Etiquetas.CalleNro}}</mat-label>
                        <input type="text" matInput formControlName="calleNro">
                    </mat-form-field>
                </div>


                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.CodigoBodegaCoagra}}</mat-label>
                        <input type="text" matInput formControlName="codigoCoagra">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('codigoCoagra')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>
                        
                    </mat-form-field>
                </div>

            </div>
        </form>
            
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardar()" [disabled]="form.invalid" mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>